import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsRockClimbingNormalXsmall = React.forwardRef(
  ({ color = "currentColor", size = 16, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        d="M1 1.115L.116 2l.623.623c.226.226.296.661.114 1.18a2.401 2.401 0 00-.09.325l-.088.437a.996.996 0 00-.04.142L.09 7.414c-.06.3-.091.606-.091.912v1.12a3.553 3.553 0 005.79 2.76l.986-.798.004.006.172-.125 6.916 1.103A1.842 1.842 0 0016 10.572c0-.962-.284-1.904-.818-2.705l-.3-.451a5.293 5.293 0 00-1.63-1.575l-5.096-3.14a1.958 1.958 0 00-2.743.722L4.158 5.699l-.557-.77a2.46 2.46 0 00-1.492-.967c.182-.705.148-1.59-.486-2.224zm13.064 10.042L7.36 10.09 6.4 8.773l8.316 1.303c.023.164.034.33.034.496a.592.592 0 01-.686.585zM4.971 6.815l1.537-2.789a.708.708 0 01.992-.26l.702.432-.908 1.814 1.119.559.857-1.715.716.44-.825 1.65 1.118.558.775-1.55 1.542.951c.498.306.922.717 1.246 1.203l.3.45c.039.06.076.12.112.18L5.357 7.345zM3 6.238l3.037 4.159-1.034.838a2.303 2.303 0 01-3.754-1.79v-1.12c0-.223.022-.445.066-.664l.5-2.483c.307.053.586.225.772.483l.416.575z"
        fill=""
      />
    </svg>
  )
);
SvgSportsRockClimbingNormalXsmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsRockClimbingNormalXsmall;
